import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment'
import _ from 'lodash'
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import TableFooter from '@material-ui/core/TableFooter';
import { green, red } from '@material-ui/core/colors'; 
import RemoveCircle from '@material-ui/icons/RemoveCircle';
import AddCircleOutline from '@material-ui/icons/AddCircleOutline';
import PropTypes from 'prop-types';
import {observable} from 'mobx'
import { inject, observer } from 'mobx-react';
import {pending} from '../stores/State'
import CompareArrows from '@material-ui/icons/CompareArrows';
import TRANSACTION_TYPE from '../models/TransactionType'
import TransactionsTable from './TransactionsTable';
import {withRouter} from "react-router-dom";

@inject('store')
@observer
class AccountTransactions extends Component {
  componentWillReceiveProps(nextProps){
    if(!_.isEqual(this.props, nextProps)) this.fetchTransactions(nextProps.accountId);
  }

  componentDidMount(){
    this.fetchTransactions();
  }

  handlePageChange(page){
    const store = this.props.store.accountTransactionsUIStore;
    store.setPage(page);
    this.fetchTransactions();
  }

  handleRowsPerPageChange(rowsPerPage){
    const store = this.props.store.accountTransactionsUIStore;
    store.setRowsPerPage(rowsPerPage);
    this.fetchTransactions()
  }

  fetchTransactions(accountId){
    const store = this.props.store.transactionStore;
    const uiStore = this.props.store.accountTransactionsUIStore;    
    store.fetchAccountTransactions(accountId || this.props.accountId, uiStore.rowsPerPage, uiStore.page);
  }
  handleRowClick(transaction){
    this.props.history.push(`/groups/${transaction.campaign_prefix}/tokens/${transaction.token}`);        
  }

  render() {
    const { classes } = this.props;
    const store = this.props.store.transactionStore;
    const uiStore = this.props.store.accountTransactionsUIStore;    
    
    return (
      <Paper className={classes.paper}>
        <Typography className={classes.title} variant='subheading'><CompareArrows/>Latest transactions</Typography>
        { store.transactionsState === pending && <CircularProgress /> }
        { store.transactions && 
          <TransactionsTable
            transactions={store.transactions.results}
            count={store.transactions.count}
            rowsPerPage={uiStore.rowsPerPage}
            page={uiStore.page}
            onChangePage={(event, page)=>this.handlePageChange(page)}
            onChangeRowsPerPage={(event)=>this.handleRowsPerPageChange(event.target.value)}
            handleRowClick={this.handleRowClick.bind(this)}
          /> }
        </Paper>
    );
  }
}

const styles = theme => ({
  paper: {
    padding: 20
  },
  addIcon:{
    color: green[500]
  },
  removeIcon:{
    color: red[500]
  },
  title:{
    display: 'flex',
    alignItems: 'center'
  }
});

AccountTransactions.propTypes = {
  accountId: PropTypes.number
}

export default withRouter(withStyles(styles)(AccountTransactions));



// WEBPACK FOOTER //
// ./src/components/AccountTransactions.js